import { ContentStateInterface, InsertionIdentification } from '../../../../@types/types'
import { RealEstateDTO } from '../../../../@types/real-estate-api-types'
import { estateToApi } from './estate/estateToApi'
import { attachmentsToApi } from './attachments/attachmentsToApi'
import { multimediaOperationsToApi } from './multimediaOperations/multimediaOperationsToApi'
import { AddressFeatureState, FlowState, MultimediaState } from '../../../../@types/state-types'

export const realEstateToApi = (
  ident: InsertionIdentification,
  insertionData: ContentStateInterface,
  multimediaFeature: MultimediaState,
  flowFeature: FlowState,
  addressFeature: AddressFeatureState
): RealEstateDTO => {
  const isDepositGuaranteeEnabled = flowFeature.flowInformation.options?.depositGuaranteeEnabled === true

  return {
    attachments: attachmentsToApi(multimediaFeature.attachments),
    estate: estateToApi(ident, insertionData, addressFeature, flowFeature.flowInformation),
    isDepositGuaranteeAllowed: isDepositGuaranteeEnabled ? (insertionData.isDepositGuaranteeAllowed ?? false) : null,
    multimediaOperations: multimediaOperationsToApi(multimediaFeature),
  }
}
